/* eslint-disable */
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";
import { MdKeyboardArrowDown, MdKeyboardArrowRight } from "react-icons/md";
// chakra imports

// UI-only grouping of flat routes into a collapsible sidebar section.
// Does NOT change routes.js's flat shape (still consumed as-is for page routing).
const SIDEBAR_GROUPS = [
  {
    groupName: "Products",
    pathNames: ["ProductsList", "ProductsListEssay", "ProductUnits"],
  },
  {
    groupName: "Mouvements",
    pathNames: [
      "DepotsMovemments",
      "ProductsMovements",
      "DepotsMovemmentsEssay",
      "ProductsMovementsEssay",
    ],
  },
  {
    groupName: "Transfert de stock",
    pathNames: ["StockTransfert", "StockTransfertEssay"],
  },
];

export function SidebarLinks(props) {
  // Chakra color mode
  let location = useLocation();

  const { routes } = props;

  const [openGroups, setOpenGroups] = useState({});

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeID) => {
    const SplitedActiveRoute = location.pathname.split("/")
    const activeRouteID = SplitedActiveRoute[SplitedActiveRoute.length - 1]

    console.log("", activeRouteID)

    return activeRouteID == routeID;
  };

  const renderLink = (route, index) => (
    <Link key={index} to={route.layout + "/" + route.pathName + "/" + route.id}>
      <div className="relative mb-3 flex hover:cursor-pointer">
        <li
          className="my-[3px] flex cursor-pointer items-center px-8"
          key={index}
        >
          <span
            className={`${
              activeRoute(route.id) === true
                ? "font-bold text-brand-500 dark:text-white"
                : "font-medium text-gray-600"
            }`}
          >
            {route.icon ? route.icon : <DashIcon />}{" "}
          </span>
          <p
            className={`leading-1 ml-4 flex ${
              activeRoute(route.id) === true
                ? "font-bold text-navy-700 dark:text-white"
                : "font-medium text-gray-600"
            }`}
          >
            {route.name}
          </p>
        </li>
        {activeRoute(route.id) ? (
          <div class="absolute right-0 top-px h-9 w-1 rounded-lg bg-brand-500 dark:bg-brand-400" />
        ) : null}
      </div>
    </Link>
  );

  const renderGroup = (group, groupRoutes, index) => {
    const isGroupActive = groupRoutes.some((route) => activeRoute(route.id));
    const isOpen = openGroups[group.groupName] ?? isGroupActive;

    return (
      <div key={`group-${index}`}>
        <div
          className="relative mb-3 flex hover:cursor-pointer"
          onClick={() =>
            setOpenGroups((prev) => ({
              ...prev,
              [group.groupName]: !isOpen,
            }))
          }
        >
          <li className="my-[3px] flex w-full cursor-pointer items-center justify-between px-8">
            <div className="flex items-center">
              <span
                className={`${
                  isGroupActive
                    ? "font-bold text-brand-500 dark:text-white"
                    : "font-medium text-gray-600"
                }`}
              >
                {groupRoutes[0]?.icon ? groupRoutes[0].icon : <DashIcon />}{" "}
              </span>
              <p
                className={`leading-1 ml-4 flex ${
                  isGroupActive
                    ? "font-bold text-navy-700 dark:text-white"
                    : "font-medium text-gray-600"
                }`}
              >
                {group.groupName}
              </p>
            </div>
            {isOpen ? (
              <MdKeyboardArrowDown className="text-gray-600" />
            ) : (
              <MdKeyboardArrowRight className="text-gray-600" />
            )}
          </li>
        </div>
        {isOpen && (
          <div className="ml-4">
            {groupRoutes.map((route, subIndex) =>
              renderLink(route, `${index}-${subIndex}`)
            )}
          </div>
        )}
      </div>
    );
  };

  const createLinks = (routes) => {
    const renderedPathNames = new Set();
    const elements = [];

    routes.forEach((route, index) => {
      if (route.layout !== "/admin" && route.layout !== "/rtl") return;
      if (renderedPathNames.has(route.pathName)) return;

      const group = SIDEBAR_GROUPS.find((g) =>
        g.pathNames.includes(route.pathName)
      );

      if (group) {
        const groupRoutes = routes.filter(
          (r) =>
            group.pathNames.includes(r.pathName) &&
            (r.layout === "/admin" || r.layout === "/rtl")
        );
        groupRoutes.forEach((r) => renderedPathNames.add(r.pathName));
        elements.push(renderGroup(group, groupRoutes, index));
      } else {
        renderedPathNames.add(route.pathName);
        elements.push(renderLink(route, index));
      }
    });

    return elements;
  };
  // BRAND
  return createLinks(routes);
}

export default SidebarLinks;
